module.exports = __webpack_public_path__ + "img/defaultStaffPhoto.37c3ea6b.png";